<template>
    <div>

        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="closeErrorAndRedirect"
            />
        </div>

        <v-container>
            <v-form ref="form">
                <v-row>
                    <h2 class="pb-5 pl-7">{{ this.parentObject.pageTitle }}<span class="page_title_value pl-1">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-row>
                    <div class="pt-2 pl-7 pb-5">
                        <v-row>
                        <v-col>
                        <v-btn
                            color="warning"
                            style="width: 70px;"
                            @click="backHandler"
                            >
                            {{$t('button.back') }}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>

                <v-container id="scroll-target" class="overflow-y-auto px-5">
                    <div>
                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.appraisalcode')"
                                    ref="reviewcode"
                                    readonly
                                    v-model="formData.reviewcode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="8" sm="8" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.appraisaldesc')"
                                    ref="description"
                                    readonly
                                    v-model="formData.description"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodstartdate')"
                                    ref="startdate"
                                    type="date"
                                    readonly
                                    v-model="formData.startdate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodenddate')"
                                    ref="enddate"
                                    type="date"
                                    readonly
                                    v-model="formData.enddate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.assessmenttype')"
                                    ref="assessmentcode"
                                    readonly
                                    v-model="formData.assessmentcode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>

                    <v-card>
                        <div class="ma-4">
                            <v-subheader class="blue--text">{{$t('reportsparam.parameters')}}</v-subheader>
                            <v-row v-if="formData.assessmentcode != 'CONFIRMATION'">
                                <v-col cols="3" sm="3" class="pb-n5">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.servicerecordasatdate')"
                                        type="date"
                                        ref="servicerecasatdate"
                                        :rules="[rules.required]"
                                        v-model="formDataParameter.servicerecasatdate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row v-if="formData.assessmentcode != 'CONFIRMATION'">
                                <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.hirecutoffdate')"
                                        type="date"
                                        ref="hiredate"
                                        :rules="[rules.required]"
                                        v-model="formDataParameter.hiredate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>


                                <v-col cols="5" sm="5" class="pb-n5 mt-n6">
                                    <h4 class="pt-3 grey--text font-weight-light">{{$t('pmreviewexercise.staffwithhiredate')}}</h4>
                                </v-col>

                            </v-row>

                            <v-row v-if="formData.assessmentcode != 'CONFIRMATION'">
                                <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.cessationcutoffdate')"
                                        type="date"
                                        ref="cessationdate"
                                        :rules="[rules.required]"
                                        v-model="formDataParameter.cessationdate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>


                                <v-col cols="5" sm="5" class="pb-n5 mt-n6">
                                    <h4 class="pt-3 grey--text font-weight-light">{{$t('pmreviewexercise.staffwithcessationdate')}}</h4>
                                </v-col>

                            </v-row>

                            <v-row v-if="formData.assessmentcode != 'CONFIRMATION'">
                                <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.confirmationcutoffdate')"
                                        type="date"
                                        ref="confirmdate"
                                        :rules="[rules.required]"
                                        v-model="formDataParameter.confirmdate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>


                                <v-col cols="5" sm="5" class="pb-n5 mt-n6">
                                    <h4 class="pt-3 grey--text font-weight-light">{{$t('pmreviewexercise.staffpriorconfirmationdate')}}</h4>
                                </v-col>

                            </v-row>

                            <v-row v-if="formData.assessmentcode == 'CONFIRMATION'">
                                <v-col cols="3" sm="3" class="pb-n5">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.confirmationstartdate')"
                                        type="date"
                                        ref="confirmstartdate"
                                        v-model="formDataParameter.confirmstartdate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" sm="3" class="pb-n5">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.confirmationenddate')"
                                        type="date"
                                        ref="confirmenddate"
                                        v-model="formDataParameter.confirmenddate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="5" sm="5" class="pb-n5">
                                    <h4 class="pt-3 grey--text font-weight-light">{{$t('pmreviewexercise.applicableonlyforconfirmationreview')}}</h4>
                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col cols="1" sm="1" class="pb-n5 mt-n6">
                                    <v-checkbox
                                        class="ml-n6"
                                        ref="isOverwrite"
                                        v-model="formDataParameter.isOverwrite"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-checkbox>
                                </v-col>


                                <v-col cols="7" sm="7" class="pb-n5 mt-n6 ml-n10">
                                    <h4 class="pt-3 grey--text font-weight-light">{{$t('pmreviewexercise.overwriteexsitingrecords')}}</h4>
                                </v-col>

                            </v-row>
                        </div>
                    </v-card>

                    <app-parameter
                        class="mt-5 mb-3"
                        v-on:input="parameters = $event"
                        v-bind:parentObject="{
                            parameters: this.parameters,
                            filter: this.showFilter,
                        }"
                    />
                </v-container>

                <v-row>
                    <div class="pt-5 pl-7">
                        <v-row>
                        <v-col>
                        <v-btn
                            color="primary"
                            style="width: 100px; margin-bottom: 20px;"
                            @click="generateHandler"
                            >
                            {{$t('button.generate')}}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>


            </v-form>
            <v-overlay :value="loading" absolute>
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-dialog v-model="showLogDialog" max-width="700" persistent>
                <v-card>
                    <v-card-title class="headline">{{ $t('performancemanagement.generationcomplete') }}</v-card-title>
                    <v-card-text>
                        <v-alert type="success" dense class="mb-2">
                            {{ generationLog.newlyInserted }} {{ $t('performancemanagement.staffnewlygenerated') }}
                        </v-alert>
                        <v-alert v-if="generationLog.alreadyExisted > 0" type="info" dense class="mb-2">
                            {{ generationLog.alreadyExisted }} {{ $t('performancemanagement.staffalreadyexisted') }}
                        </v-alert>
                        <v-alert v-if="generationLog.skipped.length > 0" type="warning" dense class="mb-2">
                            {{ generationLog.skipped.length }} {{ $t('performancemanagement.staffexcluded') }}
                        </v-alert>
                        <v-data-table
                            v-if="generationLog.skipped.length > 0"
                            :headers="skippedHeaders"
                            :items="generationLog.skipped"
                            dense
                            class="elevation-1"
                            :items-per-page="5"
                        ></v-data-table>
                        <p v-else class="mt-2 grey--text">{{ $t('performancemanagement.allstaffincluded') }}</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            v-if="generationLog.skipped.length > 0"
                            color="secondary"
                            text
                            @click="downloadGenerationLog"
                        >
                            {{ $t('button.downloadlog') }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="generationLog.newlyInserted === 0 && generationLog.alreadyExisted === 0"
                            color="warning"
                            @click="backFromLogDialog"
                        >
                            {{ $t('button.back') }}
                        </v-btn>
                        <v-btn
                            v-else
                            color="primary"
                            @click="goToReviewExerciseGenerateStaff"
                        >
                            {{ $t('performancemanagement.viewgeneratedstaff') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
// import moment from "moment";
import FilterParameter from '../../../components/performance/reviewexercise/FilterParameter';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
       'app-parameter': FilterParameter,
       'app-error': ErrorDialog,
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },

            //Review Exercise
            formData: {
                pmreviewexerciseid: this.parentObject.data.id,
                reviewcode: this.parentObject.data.reviewcode,
                description: this.parentObject.data.description,
                assessmentid: this.parentObject.data.assessmentid,
                assessmentcode: this.parentObject.data.assessmentcode,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                staffFirst: this.parentObject.data.staffFirst,
                stamp: this.parentObject.data.stamp,
                userid: this.$store.getters.userId,
            },

            //Date Parameters
            formDataParameter: {
                servicerecasatdate: this.parentObject.dataParameter.servicerecasatdate,
                hiredate: this.parentObject.dataParameter.hiredate,
                cessationdate: this.parentObject.dataParameter.cessationdate,
                confirmdate: this.parentObject.dataParameter.confirmdate,
                confirmstartdate: this.parentObject.dataParameter.confirmstartdate,
                confirmenddate: this.parentObject.dataParameter.confirmenddate,
                isOverwrite: this.parentObject.dataParameter.isOverwrite,
            },

            //Filter Parameters
            parameters: {
                companyid: this.parentObject.parameters.companyid,
                compnyname: this.parentObject.parameters.compnyname,
                branchid: this.parentObject.parameters.branchid,
                brchname: this.parentObject.parameters.brchname,
                departmentid: this.parentObject.parameters.departmentid,
                deptname: this.parentObject.parameters.deptname,
                divisionid: this.parentObject.parameters.divisionid,
                divnname: this.parentObject.parameters.divnname,
                sectionid: this.parentObject.parameters.sectionid,
                sectioname: this.parentObject.parameters.sectioname,
                unitid: this.parentObject.parameters.unitid,
                unitname: this.parentObject.parameters.unitname,
                gradeid: this.parentObject.parameters.gradeid,
                grddesc: this.parentObject.parameters.grddesc,
                employmenttypeid: this.parentObject.parameters.employmenttypeid,
                emptypecatdesc: this.parentObject.parameters.emptypecatdesc,
                staffid: this.parentObject.parameters.staffid,
                staffcode: this.parentObject.parameters.staffcode,
                jobid: this.parentObject.parameters.jobid,
                jobtitle: this.parentObject.parameters.jobtitle,
            },

            showFilter: {
                companyid: true,
                branchid: true,
                departmentid: true,
                divisionid: true,
                sectionid: true,
                unitid: true,
                gradeid: true,
                employmenttypeid: true,
                staffid: true,
                jobid: true,
            },

            loading: false,

            errMsg: "",
            isErr: false,

            showLogDialog: false,
            generationLog: {
                newlyInserted: 0,
                alreadyExisted: 0,
                skipped: [],
            },
            skippedHeaders: [
                { text: this.$t('columns.staffcode'), value: 'staffcode', sortable: false },
                { text: this.$t('columns.staffname'), value: 'staffname', sortable: false },
                { text: this.$t('columns.reason'), value: 'reason', sortable: false },
            ],
        }
    },

    methods: {
        closeErrorAndRedirect() {
            this.isErr = false;
            this.$router.push({ name: 'reviewexerciselist' });
        },

        async generateHandler(){
            this.loading = true;
            await this.generateStaff();
            if (this.isErr) { this.loading = false; return; }
            await this.addReviewer();
            if (this.isErr) { this.loading = false; }
        },

        backHandler(){
            this.$router.push({ name: "reviewexerciseedit", params: { id: this.parentObject.data.id } });
        },

        backFromLogDialog() {
            this.showLogDialog = false;
            this.loading = false;
        },

        goToReviewExerciseGenerateStaff() {
            this.showLogDialog = false;
            this.loading = false;
            this.$router.push({ name: 'reviewexercisegeneratestaff', params: { formData: this.formData, formDataParameter: this.formDataParameter, parameters: this.parameters } });
        },

        downloadGenerationLog() {
            const headers = ['Staff Code', 'Staff Name', 'Reason'];
            const rows = this.generationLog.skipped.map(s => [
                s.staffcode || '',
                s.staffname || '',
                s.reason || '',
            ]);
            const csvContent = [headers, ...rows]
                .map(row => row.map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))
                .join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `review-generation-log-${this.formData.reviewcode}.csv`;
            link.click();
            URL.revokeObjectURL(url);
        },

        updateValue() {
            this.$emit("input", {
                servicerecasatdate: this.formDataParameter.servicerecasatdate,
                hiredate: this.formDataParameter.hiredate,
                cessationdate: this.formDataParameter.cessationdate,
                confirmdate: this.formDataParameter.confirmdate,
                isOverwrite: this.formDataParameter.isOverwrite,

            });
        },

        async generateStaff() {
            const vm = this;
            const data = {
                formData: vm.formData,
                formDataParameter: vm.formDataParameter,
                parameters: vm.parameters,
            };

            try {
                const res = await this.$store.dispatch('post', { url: "/reviewexercise/generate/", payload: data });
                console.log("RESGENERATESTAFF", res.status);
                if (res.status === 201 || res.status === 200) {
                    // newlyInserted is set later from addReviewer's insertedRecords
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error || res.data.message || 'An unexpected error occurred.';
                }
            } catch (err) {
                console.error('Error in generateStaff:', err);
                vm.isErr = true;
                vm.errMsg = err.message || String(err);
            }
        },

        async addReviewer() {
            const vm = this;
            const data = {
                formData: vm.formData,
                formDataParameter: vm.formDataParameter,
                parameters: vm.parameters,
            };

            try {
                const res = await this.$store.dispatch('post', { url: "/reviewexercise/generate/reviewer/", payload: data });

                if (res.status === 201) {
                    console.log("RESADDREVIEWER", res);
                    vm.generationLog.newlyInserted = res.data.newlyAssigned || 0;
                    vm.generationLog.alreadyExisted = res.data.alreadyHadReviewer || 0;
                    vm.generationLog.skipped = res.data.skippedStaff || [];
                    await vm.removeStaff(res.data.insertedRecords);
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data?.error || res.data?.message || 'An unexpected error occurred.';
                }
            } catch (err) {
                console.error('Error in addReviewer:', err);
                vm.isErr = true;
                vm.errMsg = err.response?.data?.error || err.message || String(err);
            }
        },

        async removeStaff(staffRecords){
            const vm = this;

            try {
                const res = await this.$store.dispatch('put', { url: "/reviewexercise/staff/generate/" + vm.formData.pmreviewexerciseid, payload: staffRecords});

                console.log("RESREMOVESTAFF", res);

                if (res.data.status === 201) {
                    vm.loading = false;
                    vm.showLogDialog = true;
                } else {
                    vm.isErr = true;
                }
            } catch (err) {
                console.error('Error in removeStaff:', err);
                vm.isErr = true;
                vm.errMsg = err.message || String(err);
            }
        },

        //No more in use because separated initiate Workflow
        //Keep for now in case if ever need for future use
        // async generateWfTran(staffRecords, staffFirst){
        //     ...
        // }

    },

    mounted(){

    }
}
</script>
